/* eslint-disable camelcase */
import { Router } from 'vue-router';
import { DailyPunchTypeEnum } from '~/src/api/modules/exam/types';
import { AnswerModeEnum, ExamModeEnum } from '~/src/constants/exam';
import { RouteNames } from '~/src/router/constants';

export const generateExamResultUrl = (
  router: Router,
  payload: {
    mode: ExamModeEnum;
    answerMode?: AnswerModeEnum;
    answerId?: string;
    submitId?: string;
    id?: string;
    type?: DailyPunchTypeEnum;
    date?: string;
    autoShowPoster?: string;
    userSubject?: string;
    highFrequency?: string;
    today?: string;
    number?: string;
  }
) => {
  return router.resolve({
    name: RouteNames.ExamResult,
    params: {
      examMode: payload.mode,
      id: payload.id,
    },
    query: {
      answerMode: payload.answerMode,
      answer_id: payload.answerId,
      submit_id: payload.submitId,
      type: payload.type,
      date: payload.date,
      autoShowPoster: payload.autoShowPoster,
      userSubject: payload.userSubject,
      highFrequency: payload.highFrequency,
      today: payload.today,
      number: payload.number,
    },
  });
};

export const generateExamAnswerUrl = (
  router: Router,
  payload: {
    id?: string;
    mode: ExamModeEnum;
    answerMode?: AnswerModeEnum;
    type?: string;
    date?: string;
    version?: string;
    tradeNumber?: string;
    exchangeType?: string;
    userSubject?: string;
    highFrequency?: string;
    today?: string;
  }
) => {
  return router.resolve({
    name: RouteNames.ExamAnswer,
    params: {
      examMode: payload.mode,
      id: payload.id,
    },
    query: {
      answerMode: payload.answerMode,
      type: payload.type,
      date: payload.date,
      version: payload.version,
      tradeNumber: payload.tradeNumber,
      exchangeType: payload.exchangeType,
      userSubject: payload.userSubject,
      highFrequency: payload.highFrequency,
      today: payload.today,
    },
  });
};

export const generateExamAnalyzeUrl = (
  router: Router,
  payload: {
    id?: string;
    mode: ExamModeEnum;
    answerMode?: AnswerModeEnum;
    type?: string;
    date?: string;
    submitId?: string;
    highFrequencyShow?: string;
    hash?: string;
    showType?: string;
    userSubject?: string;
    highFrequency?: string;
    today?: string;
    number?: string;
  }
) => {
  return router.resolve({
    name: RouteNames.ExamAnalyze,
    params: {
      examMode: payload.mode,
      id: payload.id,
    },
    query: {
      type: payload.type,
      date: payload.date,
      answerMode: payload.answerMode,
      submit_id: payload.submitId,
      highFrequencyShow: payload.highFrequencyShow,
      showType: payload.showType,
      userSubject: payload.userSubject,
      highFrequency: payload.highFrequency,
      today: payload.today,
      number: payload.number,
    },
    hash: payload.hash,
  });
};

export const generateExamDetailUrl = (
  router: Router,
  payload: {
    name: string;
    id: string;
    version?: string;
  }
) => {
  return router.resolve({
    name: payload.name,
    params: {
      id: payload.id,
    },
    query: {
      version: payload.version,
    },
  });
};
